module.exports = __webpack_public_path__ + "img/EX2_recog_sad.7e80844d.jpg";